var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "solid-border" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", { staticClass: "left-border" }),
      _vm._v(" "),
      _c("div", { staticClass: "right-border" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }